import { Component } from '@angular/core';
import { AppState } from '../../../app.state';
import { User } from '../../services/user/models/user.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'upsc-complaints',
    templateUrl: './complaints.component.html',
    styleUrls: ['./complaints.component.scss'],
})

export class ComplaintsComponent {
    private user: User;
    public complaintText: string;

    public constructor(private readonly appState: AppState,
                        private translate: TranslateService
    ) {
        this.user = this.appState.user$();
    }
    ngOnInit() {
        this.translate.get('complaints.0').subscribe(() => {
            this.complaintText = this.getSupportEmailAddress();
          });
    }
    public isGBUser() {
        if (this.user.CustomerId.substr(0, 2) === 'GB') {
            return true;
        } else {
            return false;
        }
    }
    
    public getSupportEmailAddress(){
        switch(this.user.CustomerId.substr(0, 2)){
            case 'GB':
                return 'risksolutionsuk@ups.com';
            case 'FR':
                return 'risksolutionsfr@ups.com'
            case 'IT':
                return 'risksolutionsit@ups.com'
            default:
                return 'risksolutionsde@ups.com';
        }
    }

    public isENGB(): boolean {
        if (sessionStorage.getItem('lang') && sessionStorage.getItem('lang').toString() === 'en-gb') {
            return true;
        } else {
            return false;
        }
    }
    public isIT(): boolean {
        if (sessionStorage.getItem('lang') && sessionStorage.getItem('lang').toString() === 'it') {
            return true;
        } else {
            return false;
        }
    }
    public isITUser() {
        if (this.user.CustomerId.substr(0, 2) === 'IT') {
            return true;
        } else {
            return false;
        }
    }
    public isFRUser() {
        if (this.user.CustomerId.substr(0, 2) === 'FR') {
            return true;
        } else {
            return false;
        }
    }
    public isFR(): boolean {
        if (sessionStorage.getItem('lang') && sessionStorage.getItem('lang').toString() === 'fr') {
            return true;
        } else {
            return false;
        }
    }
}
